function scrollToElementOnPageLoad() {
	// Default configuration options
	const defaults = {
		scrollDuration: 500, // Duration of the smooth scroll in milliseconds
		easingType: "ease-in-out", // Type of easing
		easingStrength: "medium", // Strength of easing
		offset: -350, // Offset value in pixels
		targetElement: document.querySelector("[js-scroll-to-me]"), // Element to scroll to
		animationDelay: 100 // Delay in milliseconds to wait for other animations
	};

	if (defaults.targetElement) {
		// Wait for the specified delay before starting the scroll
		setTimeout(function () {
			try {
				smoothScrollTo();
			} catch (error) {
				console.error("Error:", error);
			}
		}, defaults.animationDelay);
	}

	// Function to perform the smooth scroll
	function smoothScrollTo() {
		const { scrollDuration, easingType, easingStrength, offset, targetElement } = defaults;
		const easingStrengthMultipliers = {
			strong: 3,
			medium: 1,
			gentle: 4
		};
		const easingFunctions = {
			"ease-in": (progressRatio, multiplier) => progressRatio ** multiplier,
			"ease-out": (progressRatio, multiplier) => 1 - (1 - progressRatio) ** multiplier,
			"ease-in-out": (progressRatio, multiplier) => (progressRatio < 0.5 ? multiplier * progressRatio ** multiplier : 1 - multiplier * (1 - progressRatio) ** multiplier)
		};
		const multiplier = easingStrengthMultipliers[easingStrength] || easingStrengthMultipliers.medium;
		const easingFunction = easingFunctions[easingType] || easingFunctions["ease-in-out"];
		const targetPosition = targetElement.getBoundingClientRect().top + offset;
		const startPosition = window.pageYOffset;
		const distance = targetPosition - startPosition;
		let start = null;

		function step(timestamp) {
			if (!start) start = timestamp;
			const progress = timestamp - start;
			const progressRatio = Math.min(progress / scrollDuration, 1);
			const easing = easingFunction(progressRatio, multiplier);
			window.scrollTo(0, startPosition + distance * easing);
			if (progress < scrollDuration) window.requestAnimationFrame(step);
		}

		window.requestAnimationFrame(step);
	}
}

// Call the function to initiate the smooth scroll on page load
document.addEventListener("DOMContentLoaded", function () {
	scrollToElementOnPageLoad();
});
